import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';
// import FactAnimation from './FactAnimation';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: '#00457A',
    paddingTop: 81,
    paddingBottom: 81,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 77,
      paddingBottom: 77,
    },
  },
  container: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    fontFamily: 'PoppinsBold',
    fontWeight: '700',
    fontSize: 35,
    lineHeight: '48px',
    textAlign: 'center',
    paddingBottom: 10,
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      marginTop: 27,
    },
  },
  factsWrapper: {
    marginTop: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: 30,
    },
  },
  itemWrapper: {
    width: '20.875%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  itemImage: {
    width: '100%',
    height: 'auto',
  },
  itemLabel: {
    textAlign: 'center',
    color: '#FFFFFF',
    fontFamily: 'OpenSansBold',
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '20px',
  },
}));

function StatsSection() {
  const classes = useStyles();

  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.stats-section', {});

  return (
    <section id="stats-section">
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <Typography className={classes.header}>{config.title}</Typography>
          <div className={classes.factsWrapper}>
            {config.items.map(item => (
              <div className={classes.itemWrapper}>
                <a href={item.url} target="_blank">
                  <img
                    src={item.image}
                    className={classes.itemImage}
                    alt={item.label}
                  />
                </a>
                <Typography className={classes.itemLabel}>
                  {item.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default StatsSection;
